import React from 'react';
import styles from './TagBadge.module.css';

const categoryClassMap = {
  profession: styles.profession,
  hobby: styles.hobby,
  skill: styles.skill,
};

const TagBadge = ({ label, category, onClick }) => {
  if (!label) return null;

  const categoryClass = category ? categoryClassMap[category] : '';

  return (
    <button
      type="button"
      className={`${styles.tag} ${categoryClass}`.trim()}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

export default TagBadge;
